{
  "drawer": {
    "title": "Page help",
    "close": "Close"
  },
  "manual": {
    "title": "Manual",
    "subtitle": "Full HydraHive2 documentation",
    "sections": {
      "concepts": "Concepts",
      "usage": "Usage",
      "faq": "FAQ",
      "glossary": "Glossary"
    },
    "topics": {
      "onboarding": "Getting started",
      "buddy": "Buddy (assistant)",
      "butler": "Butler (automations)",
      "credentials": "Credentials",
      "architecture": "3-Tier Architecture",
      "compaction": "Compaction",
      "mcp": "MCP Protocol",
      "tools": "Tools",
      "workspaces": "Workspaces",
      "dashboard": "Dashboard",
      "chat": "Chat",
      "agents": "Agents",
      "projects": "Projects",
      "llm": "LLM Configuration",
      "mcp_servers": "MCP Servers",
      "system": "System",
      "faq_general": "General",
      "faq_errors": "Error messages",
      "faq_setup": "Setup",
      "glossary_main": "Terms A-Z",
      "skills": "Skills",
      "memory": "Memory",
      "datamining": "Datamining",
      "communication": "Communication",
      "teamchat": "Team chat",
      "atelier": "Atelier (media)",
      "vms": "Virtual Machines",
      "containers": "Containers",
      "users": "Users",
      "patientenakte": "My Record",
      "cryptoboard": "Cryptoboard",
      "notizbuch": "Notebook",
      "scratchpad": "Scratchpad",
      "deepresearch": "Deep Research",
      "homeassistant": "Home Assistant",
      "archiver": "Archiver",
      "blueprint": "Blueprint",
      "boardgames": "Board games",
      "minigames": "Minigames",
      "musicplayer": "Music",
      "tasks": "Tasks",
      "videoeditor": "Video editor",
      "zahnfee": "Tooth Fairy",
      "plugins": "Plugins",
      "federation": "Federation",
      "streaming": "Streaming",
      "extensions": "Extensions"
    }
  }
}